import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'
import { applyTheme, defaultTheme } from './theme.js'
import appFavicon from './assets/PRNlogo.svg'
import UsageGuide from './pages/UsageGuide.jsx'
import { BrowserRouter, Routes, Route } from 'react-router-dom'

applyTheme(defaultTheme)

const favicon = document.querySelector('#app-favicon')
if (favicon) {
  favicon.href = appFavicon
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/guide" element={<UsageGuide />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
)
